import type * as React from 'react';
import { motion } from 'framer-motion';

import { mediumSpring } from '@/constants/animation';

export default function CellPresence({
  style,
  ...props
}: React.ComponentPropsWithoutRef<typeof motion.div>) {
  return (
    <motion.div
      key="cell"
      {...props}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.01 } }}
      initial={{ opacity: 0, scale: 0.9, y: 200 }}
      style={{
        ...style,
        originX: 0.5,
        originY: 0
      }}
      transition={mediumSpring}
    />
  );
}
